import {
    onIsOnlineMeetingChanged,
    updateIsOnlineMeetingExplicitlySet,
} from 'owa-calendar-compose-form-actions';

import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { isFeatureEnabled } from 'owa-feature-flags';
import { orchestrator } from 'satcheljs';

orchestrator(onIsOnlineMeetingChanged, actionMessage => {
    const { event } = getComposeStore();
    if (
        event &&
        isFeatureEnabled('cal-mf-enableDefaultOnlineMeetingSetting') &&
        actionMessage.isOnlineMeetingExplicitlySet
    ) {
        updateIsOnlineMeetingExplicitlySet();
    }
});
